export default {
  tab: 'Seat list',
  title: 'Seat list',
  description: 'Review all seat assignments by layout and status; to adjust seats, use Open seat editor above.',
  export: 'Export seats',
  enterEditor: 'Open seat editor',
  totalSeats: 'Total seats',
  seatUnit: 'seats',
  assigned: 'Assigned',
  emptyLabel: 'Empty',
  usageRate: 'Usage',
  allMeetings: 'All meetings',
  allLayouts: 'All layouts',
  allStatuses: 'All statuses',
  statusAssigned: 'Assigned',
  statusEmpty: 'Empty',
  statusLocked: 'Locked',
  search: 'Search seat, name, organization, job title, or layout',
  summary: '{total} seats · {assigned} assigned · {empty} empty',
  index: 'No.',
  member: 'Participant',
  seatNo: 'Seat',
  seatNoSuffix: '',
  unit: 'Area / unit',
  layout: 'Layout',
  seatType: 'Seat type',
  session: 'Session',
  organization: 'Organization',
  jobTitle: 'Job title',
  status: 'Status',
  statuses: {
    assigned: 'Assigned',
    empty: 'Empty',
    locked: 'Locked'
  },
  adjust: 'Adjust',
  release: 'Release',
  releaseConfirm: 'Release seat {seat} from {name}?',
  releaseSuccess: 'Seat released',
  emptyState: 'No seat data'
}
